import React from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { balance, balanceSelectors } from 'store/Balance';
import { webSocketsService } from 'services/WebSockets';

export const useBalance = (): string => {
    const balanceValue = useStore(balance.store, balanceSelectors.getFormattedBalance);

    React.useEffect(() => {
        if (!balanceValue) {
            balance.store.fetchBalance();
        }
    }, []);

    React.useEffect(() => {
        const unsubscribe = webSocketsService.balance((payload) => {
            balance.store.setAmount(payload.amount);
        });

        return () => {
            unsubscribe();
        };
    }, []);

    return balanceValue;
};
